<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div>
      <header>
        <h3 class="text-brand fw-normal" tabindex="-1" #heading>
          {{convert('sellModule.offers.counter.textCounterOffer')}}
        </h3>
      </header>
      <div id="disclosures">
        <p [innerHTML]="convert('sellModule.offers.counter.textSelectingCounter', {title : title})"></p>
      </div>
      <div class="mb-4">
        <app-datalist-item class="mb-4" label="{{convert('sellModule.offers.common.labelBuyerOffer')}}"
        [value]="get('amount', false) ? formatCurrency(get('amount', false)) : 'N/A'"></app-datalist-item>
      </div>
      <div class="mb-4">
        <app-datalist-item class="mb-4" label="{{convert('sellModule.offers.common.labelBuyerComment')}}"
        [value]="offer.comment || 'N/A'"></app-datalist-item>
      </div>
      <form [formGroup]="counterForm">
        <div class="d-flex flex-column app-textarea">
          <div class="form-group mb-0">
            <label class="d-block text-start"
            for="counter-offer-comment">{{convert('sellModule.offers.common.labelComment')}}</label>
            <textarea id="counter-offer-comment" class="form-control mb-1" rows="3" maxlength="150"
              formControlName="offerComment" appCharacterCount #comment="appCharacterCount"
            (keyup)="replaceInvalidCharacters($event)"></textarea>
            <app-character-count [count]="comment.count$ | async" [maxLength]="150"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
          </div>
        </div>
        <div class="d-lg-flex mb-0">
          <div class="form-group" [class.counterForm]="localErrorMessage || incorrectAmount || isAmountEmpty">
            <label class="d-block text-start"
            for="counter-offer-amount">{{convert('sellModule.offers.counter.textCounterOfferUpper')}}</label>
            <app-currency-input
              [inputConfig]="inputConfig"
              [inputForm]="counterForm"
              [inputId]="'counter-offer-amount'"
              (inputKeyUp)="validateAmount()"
            ></app-currency-input>
          </div>
        </div>
      </form>
      <div class="error-message" aria-live="polite" tabindex="-1">
        @if (incorrectAmount) {
          <strong>{{counterOfferAmountError}}<br /></strong>
        }
        @if (localErrorMessage) {
          <strong>{{localErrorMessage}}<br /></strong>
        }
        @if (isAmountEmpty) {
          <strong>{{emptyOfferAmountError}}<br /></strong>
        }
      </div>
      <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
        <button class="btn btn-primary" type="submit" data-track-elem="button"
          [attr.data-track-name]="'Counter-' + inventoryItem.inventoryItemUuid" data-track-trigger="offer"
          [attr.data-track-region]="offer.dealershipName" [attr.data-track-id]="inventoryItem.inventoryItemUuid"
          (click)="counter()">
          {{convert('sellModule.offers.counter.btnCounter')}}
        </button>
        <button class="ms-lg-2 mt-2 mt-lg-0 btn btn-link" type="button" data-track-elem="button"
          data-track-name="Cancel" data-track-trigger="close" (click)="cancel.emit()">
          <span>{{convert('common.btnCancel')}}</span>
        </button>
      </div>
    </div>
  }
</ng-container>
